import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getSchoolClassesConfig } from '../../apis/schoolConfig';
import { RootState } from '../../redux/store';
import { SchoolClassesConfig } from '../../types/schoolConfigType';
import SubjectAndGroupingPage from './SubjectPage';
import ToastMessage from '../../components/ToastMessage';
import { SnackbarSeverityType } from '../../enums';
import { PageContainer } from './styled';
import { Typography } from '@mui/material';

const SubjectContainer: React.FC = () => {
  const [allClasses, setAllClasses] = useState<SchoolClassesConfig>();
  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState<SnackbarSeverityType>(
    SnackbarSeverityType.success
  );
  const [isLoadingConfig, setIsLoadingConfig] = useState(true);

  const handleCloseToast = () => {
    setToastOpen(false);
  };

  const showToast = (message: string, severity: SnackbarSeverityType) => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  useEffect(() => {
    getSchoolClassesConfig(loggedInUser.school)
      .then((response) => {
        setAllClasses(response.data as SchoolClassesConfig);
      })
      .catch((error) => {
        console.error(error);
        showToast('Failed to load subjects.', SnackbarSeverityType.error);
      })
      .finally(() => {
        setIsLoadingConfig(false);
      });
  }, [loggedInUser]);

  if (isLoadingConfig) {
    return (
      <PageContainer>
        <Typography>Loading subject configuration...</Typography>
      </PageContainer>
    );
  }

  return (
    <>
      <SubjectAndGroupingPage
        allClasses={allClasses}
        school={loggedInUser.school}
        onShowToast={showToast}
      />
      <ToastMessage
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={handleCloseToast}
      />
    </>
  );
};

export default SubjectContainer;
